import React, { useEffect, useState } from 'react';
import { Check, Lock, X } from 'lucide-react';
interface ExitIntentPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ExitIntentPopup({
  isOpen,
  onClose
}: ExitIntentPopupProps) {
  const [isRendered, setIsRendered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setIsRendered(true);
      // Small delay to allow DOM to render before triggering animation
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsVisible(true);
        });
      });
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    } else {
      setIsVisible(false);
      // Wait for animation to finish before unmounting
      const timer = setTimeout(() => {
        setIsRendered(false);
        document.body.style.overflow = '';
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  if (!isRendered) return null;
  const handleAccept = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        value: 590,
        currency: 'UYU',
        content_name: 'Paquete Completo (Protocolo + 2 Bumps)',
        content_type: 'product'
      });
    }
    window.location.href = 'https://resetdiario.com/cart/53265436541292:1';
  };
  const handleDecline = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        value: 290,
        currency: 'UYU',
        content_name: 'El Protocolo de Limpieza Glicémica',
        content_type: 'product'
      });
    }
    window.location.href = 'https://www.resetdiario.com/cart/53153601519980:1';
  };
  return <div className="fixed inset-0 z-[100] overflow-y-auto" data-id="element-377">
      <style data-id="element-378">{`
        @keyframes flash {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
        .animate-flash {
          animation: flash 1.5s ease-in-out infinite;
        }
        @keyframes pulse-glow {
          0% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7); }
          70% { box-shadow: 0 0 0 15px rgba(16, 185, 129, 0); }
          100% { box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
        }
        .animate-pulse-glow {
          animation: pulse-glow 2s infinite;
        }
      `}</style>

      {/* Backdrop */}
      <div className={`fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 motion-reduce:transition-none ${isVisible ? 'opacity-100' : 'opacity-0'}`} onClick={onClose} data-id="element-379" />

      {/* Scrollable centering wrapper */}
      <div className="min-h-full flex items-center justify-center p-3 sm:p-6" data-id="element-380">
        {/* Popup Container */}
        <div className={`relative w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col transition-all duration-300 motion-reduce:transition-none transform ${isVisible ? 'scale-100 opacity-100 translate-y-0' : 'scale-95 opacity-0 translate-y-4'}`} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-381">
          {/* Close Button */}
          <button onClick={onClose} className="absolute top-3 right-3 z-10 p-1.5 bg-black/10 hover:bg-black/20 rounded-full text-white transition-colors" aria-label="Cerrar" data-id="element-382">
            <X className="w-5 h-5" data-id="element-383" />
          </button>

          {/* Header Banner */}
          <div className="bg-red-600 text-white text-center py-2 px-4" data-id="element-384">
            <p className="text-xs sm:text-sm font-bold tracking-wider uppercase" data-id="element-385">
              ⏰ ¡ESPERE! OFERTA ESPECIAL DE ÚLTIMA OPORTUNIDAD
            </p>
          </div>

          <div className="p-4 sm:p-8 flex flex-col items-center text-center" data-id="element-386">
            <h2 id="modal-title" className="text-xl sm:text-3xl font-extrabold text-gray-900 mb-1.5 leading-tight" data-id="element-387">
              🚨 ¡No se vaya sin el Paquete Completo!
            </h2>
            <p className="text-xs sm:text-sm text-red-600 font-semibold mb-4" data-id="element-388">
              Esta oferta NO estará disponible después de cerrar esta ventana
            </p>

            {/* Flashing Discount Badge */}
            <div className="bg-red-100 border-2 border-red-500 text-red-700 font-black text-base sm:text-lg px-5 py-1.5 rounded-full mb-4 animate-flash motion-reduce:animate-none shadow-sm" data-id="element-389">
              30% DE DESCUENTO
            </div>

            {/* Body Copy */}
            <p className="text-sm text-gray-700 mb-2 leading-relaxed" data-id="element-390">
              Lleve TODO lo que necesita para transformar su salud glicémica en
              7 días. El Protocolo completo + el Recetario con menús de lunes a
              domingo + la Bitácora para medir sus progresos reales.
            </p>
            <p className="text-sm text-gray-700 font-medium mb-4" data-id="element-391">
              Este paquete le da las herramientas, las recetas Y el control —
              todo en un solo paso.
            </p>

            {/* What's Included List */}
            <div className="w-full bg-emerald-50 border border-emerald-100 rounded-xl p-3 sm:p-4 mb-4 text-left" data-id="element-392">
              <p className="font-bold text-emerald-900 mb-2 text-xs uppercase tracking-wide text-center" data-id="element-393">
                Lo que incluye el paquete:
              </p>
              <ul className="space-y-1.5" data-id="element-394">
                <li className="flex items-start gap-2" data-id="element-395">
                  <Check className="w-4 h-4 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-396" />
                  <span className="text-xs sm:text-sm text-gray-800 font-medium" data-id="element-397">
                    El Protocolo de Limpieza Glicémica
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-398">
                  <Check className="w-4 h-4 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-399" />
                  <span className="text-xs sm:text-sm text-gray-800 font-medium" data-id="element-400">
                    3 Bonos GRATIS: Ritual 7×1, Guía de Señales, Kit Anti-Picos
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-401">
                  <Check className="w-4 h-4 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-402" />
                  <span className="text-xs sm:text-sm text-gray-800 font-medium" data-id="element-403">
                    El Recetario de la Feria — Menú completo de 7 días
                  </span>
                </li>
                <li className="flex items-start gap-2" data-id="element-404">
                  <Check className="w-4 h-4 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-405" />
                  <span className="text-xs sm:text-sm text-gray-800 font-medium" data-id="element-406">
                    La Polis del Páncreas — Bitácora de control profesional
                  </span>
                </li>
              </ul>
            </div>

            {/* Pricing Block */}
            <div className="w-full flex flex-col items-center mb-4" data-id="element-407">
              <div className="flex items-center gap-2 text-gray-400 mb-1" data-id="element-408">
                <span className="text-xs sm:text-sm" data-id="element-409">Valor total:</span>
                <span className="text-base sm:text-lg line-through font-semibold" data-id="element-410">
                  $1.084 UYU
                </span>
              </div>
              <div className="text-4xl sm:text-5xl font-black text-emerald-600 mb-1.5 tracking-tight" data-id="element-411">
                $590 <span className="text-xl sm:text-2xl" data-id="element-412">UYU</span>
              </div>
              <div className="bg-emerald-100 text-emerald-800 text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-413">
                Usted ahorra $494 UYU
              </div>
              <div className="flex items-center gap-1.5 text-[10px] sm:text-xs text-gray-500 font-medium" data-id="element-414">
                <Lock className="w-3 h-3 sm:w-3.5 sm:h-3.5" data-id="element-415" />
                <span data-id="element-416">Precio especial solo disponible en esta pantalla</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="w-full flex flex-col gap-3" data-id="element-417">
              <button onClick={handleAccept} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-base sm:text-lg py-3.5 sm:py-4 px-5 rounded-xl shadow-lg transition-colors animate-pulse-glow motion-reduce:animate-none flex items-center justify-center" data-id="element-418">
                ¡SÍ! QUIERO EL PAQUETE COMPLETO POR $590
              </button>

              <button onClick={handleDecline} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 font-medium transition-colors underline underline-offset-4 py-1" data-id="element-419">
                No gracias, continuar sin los extras →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}